import { toArray } from "lib/utils";
import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

const FeatureList = ({ title = "", list = [], visibleCount = 2 }) => {
  const safeList = toArray(list);
  const hasExtra = safeList.length > visibleCount;
  const visible = (safeList.length - visibleCount > 0) ? safeList.slice(0, visibleCount) : safeList;
  const extraItems = hasExtra ? safeList.slice(visibleCount) : [];
  const extraCount = extraItems.length;
  // const extra = (safeList.length - visibleCount > 0) ? safeList.length - visibleCount : 0;

  return (
    <TooltipProvider>
    <div className="p-4 flex flex-col gap-2">
      {
        title &&
        <p className="text-sm font-medium text-muted-foreground">{title}</p>
      }
      <div className="flex flex-col md:flex-row items-start md:items-center gap-2">
        {visible.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-1 border border-border px-2.5 py-1.5 rounded-xl text-sm text-foreground font-medium bg-card"
          >
            {item?.name ? item.name : item}
          </div>
        ))}

        {/* {extra > 0 && (
          <div className="flex items-center justify-center border border-border px-2.5 py-1.5 rounded-xl text-sm text-foreground font-medium bg-card">
            +{extra}
          </div>
        )} */}
        {extraCount > 0 && (
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="cursor-pointer flex items-center justify-center border border-border px-2.5 py-1.5 rounded-xl text-sm text-foreground font-medium bg-card hover:bg-card/80 transition-colors">
                  +{extraCount}
                </div>
              </TooltipTrigger>
              <TooltipContent className="bg-card border p-2 rounded-lg shadow-xl">
                <div className="flex flex-col gap-1.5">
                  {extraItems.map((item, idx) => (
                    <p key={idx} className="text-sm text-foreground">
                      • {item?.name ? item.name : item}
                    </p>
                  ))}
                </div>
              </TooltipContent>
            </Tooltip>
          )}
      </div>
    </div>
    </TooltipProvider>
  );
}

export default FeatureList
